import { AppDispatch } from "../store";
import { setNotification } from "../store/toastNotifications";
import { TimeFormat } from "../types/calendarSettings";
import api, { API_PATHS } from "./api";

class CalendarSettingsService {
  static async editCalendarTimeWindow(
    filterId: number,
    startTime: TimeFormat,
    endTime: TimeFormat,
    dispatch: AppDispatch,
  ) {
    try {
      await api.post(API_PATHS.updateCalendarTimeWindow, null, {
        params: { filterId, startTime, endTime },
      });
    } catch (error: any) {
      dispatch(
        setNotification({
          message: error.message,
          type: "update_time_window_failed",
        }),
      );
      throw new Error(error.message);
    }
  }
}

export default CalendarSettingsService;
